<template>
  <div class="wrapper">
    <admin-title :title="$route.meta.name" />

    <el-form ref="form" :model="formData" :disabled="formData.status == 1" label-width="120px">
      <el-form-item label="渠道名称" prop="channelName" :rules="rules">
        <el-input v-model="formData.channelName" size="small" placeholder="请输入渠道名称" />
      </el-form-item>

      <el-form-item label="负责人" prop="companyUserName" :rules="rules">
        <el-input v-model="formData.companyUserName" size="small" placeholder="请输入负责人" />
      </el-form-item>

      <el-form-item label="负责人手机号" prop="companyUserMobile" :rules="rules">
        <el-input v-model="formData.companyUserMobile" size="small" placeholder="请输入负责人手机号" />
      </el-form-item>

      <el-form-item label="对接商务" prop="businessUserId" :rules="rules">
        <SelectAdmin v-model="formData.businessUserId" />
      </el-form-item>

      <el-form-item label="结算方式" prop="settleMethod" :rules="rules">
        <el-radio-group
            v-model="formData.settleMethod"
            placeholder="请选择结算方式"
            size="small"
        >
          <div v-for="item in settle_option_list" :key="item.value">
            <el-radio :label="item.value">
              <span style="display: inline-block;width: 20px;">{{ item.label }}</span>
              <el-input
                  v-model="item.inputValue"
                  :disabled="formData.settleMethod !== item.value"
                  :placeholder="item.placeholder"
                  style="width: 300px; margin-left: 15px"
                  size="small"
              />
            </el-radio>
          </div>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="结算备注" prop="settleRemark">
        <el-input v-model="formData.settleRemark" type="textarea" size="small" />
      </el-form-item>

      <el-form-item label="精细化数据统计规则配置" prop="dataOptRuleList">
        <div class="rule-content">
          <el-row :gutter="20" class="row">
            <el-col :span="16" class="col1"><span>数据范围</span></el-col>
            <el-col :span="6" class="col2"><span>优化比例（%）</span></el-col>
            <el-col :span="2"></el-col>
          </el-row>
          <el-row :gutter="20" class="row" v-for="(ruleItem, ruleIndex) in formData.dataOptRuleList" :key="ruleIndex">
            <el-col :span="16" class="col1">
              <span>
                <el-select
                    v-model="ruleItem.operator"
                    @change="onRuleOperatorChange(ruleIndex)"
                    style="width: 120px; margin-right: 20px;"
                    placeholder="请选择"
                    size="small"
                >
                  <el-option
                      v-for="item in OPERATOR_DICT"
                      :key="item.value"
                      :label="item.name"
                      :value="item.value"
                  >
                  </el-option>
                </el-select>
              </span>
              <span v-if="ruleItem.operator !== 'between'">
                <el-input v-model="ruleItem.hitData[0]" size="small" />
              </span>
              <span v-else>
                <el-input v-model="ruleItem.hitData[0]" size="small" />
                <span style="margin: 0 5px;">到</span>
                <el-input v-model="ruleItem.hitData[1]" size="small" />
              </span>
            </el-col>
            <el-col :span="6" class="col2">
              <el-input v-model="ruleItem.optRate" size="small" />
            </el-col>
            <el-col :span="2">
              <el-button
                  @click="onDelRuleClick(ruleIndex)"
                  type="danger"
                  icon="el-icon-delete"
                  size="mini"
                  circle
              />
            </el-col>
          </el-row>
          <div style="display: flex; align-items: center; justify-content: center; margin-top: 10px;">
            <el-button
                @click="onAddRuleClick"
                size="small"
                style="width: 200px"
                plain
                type="primary"
            >
              新增规则
            </el-button>
          </div>
        </div>
      </el-form-item>

      <el-form-item label="" label-width="0" style="margin-top:20px;text-align:center;">
        <el-button type="primary" size="small" @click="save">提交</el-button>
        <el-button type="" size="small" @click="$router.back()">取消</el-button>
      </el-form-item>
    </el-form>
    <div style="height:50px"></div>
  </div>
</template>

<script>
import { editChannelAPI, addChannelAPI, getChannelDetailAPI } from './api';
import SelectAdmin from "@/views/components/select-admin.vue";
import {OPERATOR_DICT} from "@/enum/dict";

const settle_option_list = [
  { label: "cpa", value: "cpa", inputValue: "", placeholder: "请输入单个注册用户结算金额" },
  { label: "cps", value: "cps", inputValue: "", placeholder: "请输入成交金额结算比例" },
  { label: "UV", value: "uv", inputValue: "", placeholder: "请输入UV结算价格" },
  { label: "PV", value: "pv", inputValue: "", placeholder: "请输入PV结算价格" },
];

export default {
  name: 'ChannelAddOrEdit',
  components: { SelectAdmin },
  data() {
    return {
      settle_option_list,
      OPERATOR_DICT,
      currentIndex: -1,
      formData: {
        channelName: '',
        companyUserName: '',
        companyUserMobile: '',
        businessUserId: undefined,
        settleMethod: undefined,
        settleValue: '',
        settleRemark: '',
        dataOptRuleList: [],
      },
      rules: [{ required: true, message: '该项不能为空', trigger: 'blur' }],
    }
  },
  mounted() {
    if (this.$route.params.id) this.getChannelDetail();
  },
  computed: {
    settleValue() {
      const selectedOption = this.settle_option_list.find(option => option.value === this.formData.settleMethod);
      return selectedOption?.inputValue || '';
    },
  },
  methods: {
    // 产品详情
    async getChannelDetail() {
      this.formData = await getChannelDetailAPI(this.$route.params.id);
      // 结算方式
      for (let i = 0; i < this.settle_option_list.length; i++) {
        const settleOption = this.settle_option_list[i];
        if (settleOption.value === this.formData.settleMethod) {
          settleOption.inputValue = this.formData.settleValue;
          this.settle_option_list[i] = settleOption;
          break;
        }
      }
    },
    onAddRuleClick() {
      this.formData.dataOptRuleList.push(
          {
            operator: undefined,
            hitData: [],
            optRate: undefined,
          }
      );
    },
    onDelRuleClick(ruleIndex) {
      this.$confirm('确定删除该规则吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.formData.dataOptRuleList.splice(ruleIndex, 1);
      });
    },
    onRuleOperatorChange(ruleIndex) {
      const rule = this.formData.dataOptRuleList[ruleIndex];
      rule.hitData = [];
      rule.optRate = undefined;
    },
    // 保存
    save() {
      this.formData.settleValue = this.settleValue;
      this.$refs.form.validate(() => {
        console.log('@@save', this.formData);
        if (this.formData.id) {
          // 编辑
          editChannelAPI(this.formData).then(() => {
            this.$message.success('编辑成功');
            this.$router.back();
          })
        } else {
          // 新增
          addChannelAPI(this.formData).then(() => {
            this.$message.success('新增成功');
            this.$router.back();
          })
        }
      })
    },
  }
}
</script>

<style lang="scss" scoped>
.wrapper {
  width: 100%;

  .el-form /deep/ {
    .el-input,
    .el-textarea {
      width: 400px;
    }
    .el-radio__label {
      line-height: 3;
    }
  }

  .rule-content /deep/ {
    min-width: 750px;
    max-width: 900px;
    background: #fafafa;
    border-radius: 12px;
    padding: 20px 60px;

    .row {
      display: flex;
      margin: 0;
      align-items: center;
      justify-content: center;
    }

    .col1 {
      .el-input,
      .el-input__inner {
        width: 120px !important;
      }

      display: flex;
      flex-direction: row;
    }

    .col2 {
      .el-input {
        width: 150px !important;
      }
    }
  }
}
</style>
